import SelectInput from './default';

export { SelectInput };
